/**
 * AB carousel wheel scrolling (Oct 2026, Infrastructure Redesign_Hailin)
 *
 * The Standard Product Carousel (homepage Best Sellers) is a Swiper built with the Navigation
 * module only, so on desktop it could only be moved by click-dragging or the arrows. This adds
 * normal horizontal scrolling:
 *   - trackpad horizontal swipe, or Shift + mouse wheel, moves the row 1:1 with the gesture
 *   - works with the carousel's loop mode (slides are re-arranged as you go, no jump at the end)
 *   - when the gesture stops, it settles on the nearest card (same resting positions as drag/arrows)
 *   - vertical scrolling over the carousel still scrolls the page
 *
 * The listener sits on the section container, which survives the section's Vue mount (the mount
 * replaces everything inside it, including the swiper element). The live swiper element and its
 * instance (el.swiper) are looked up on every event, so it also keeps working after the section
 * re-creates its Swiper (e.g. switching product groups). No changes to the section JS.
 */
(function () {
  if (window.__abCarouselWheel) return;
  window.__abCarouselWheel = true;

  var CONTAINER = '[data-section-type="standard-product-carousel"]';
  var SWIPER = '[data-standard-product-carousel-swiper]';
  var SETTLE_DELAY = 150; // ms without wheel input before settling on a card
  var SETTLE_SPEED = 300;

  function attach(container) {
    if (container.__abWheel) return;
    container.__abWheel = true;
    var settleTimer = null;

    container.addEventListener(
      'wheel',
      function (event) {
        var el = container.querySelector(SWIPER);
        if (!el || !el.contains(event.target)) return;
        var swiper = el.swiper;
        if (!swiper || swiper.destroyed) return;

        var dx = event.deltaX;
        var dy = event.deltaY;
        if (event.deltaMode === 1) {
          // line-based wheels (some mice / Firefox)
          dx *= 16;
          dy *= 16;
        }
        if (event.shiftKey && !dx) {
          dx = dy;
          dy = 0;
        }
        // Mostly vertical: leave it to the page
        if (!dx || Math.abs(dx) <= Math.abs(dy)) return;

        event.preventDefault();

        if (swiper.animating) swiper.animating = false;
        if (swiper.params.loop) {
          // Same call Swiper's own Mousewheel module makes: keeps slides available on the side we move to
          swiper.loopFix({ direction: dx > 0 ? 'next' : 'prev', byMousewheel: true });
        }

        var next = swiper.getTranslate() - dx;
        if (!swiper.params.loop) {
          next = Math.min(swiper.minTranslate(), Math.max(swiper.maxTranslate(), next));
        }
        swiper.setTransition(0);
        swiper.setTranslate(next);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();

        clearTimeout(settleTimer);
        settleTimer = setTimeout(function () {
          if (!swiper.destroyed) swiper.slideToClosest(SETTLE_SPEED);
        }, SETTLE_DELAY);
      },
      { passive: false }
    );
  }

  function init() {
    document.querySelectorAll(CONTAINER).forEach(attach);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
